import { KnowledgeArticleLink } from "@/components/blog/KnowledgeArticleLink";
import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';
import { knowledgeArticles, articleBySlug, areaName, guideSlug } from '@/data/knowledge';
import { DiagnosisCTA } from './DiagnosisCTA';

export function RelatedArticles({ currentSlug }: { currentSlug: string; category?: string }) {
  const current = articleBySlug(currentSlug);
  const related = knowledgeArticles.filter(article => article.slug !== currentSlug.replace(/^\//, '')).sort((a, b) => {
    const rank = (slug: string, area: string) => slug === guideSlug ? 2 : area === current?.area ? 1 : 0;
    return rank(b.slug, b.area) - rank(a.slug, a.area);
  }).slice(0, 3);
  return <div className="knowledge-related">
    <section className="mt-12 pt-10 border-t border-border" aria-label="Recursos relacionados">
      <h2 className="text-2xl mb-6">Sigue explorando</h2>
      <div className="grid sm:grid-cols-3 gap-6">{related.map(article => <div key={article.slug}>
        <p className="text-xs text-seo-bright mb-2">{areaName(article.area)}</p>
        <h3 className="text-base leading-snug mb-3"><KnowledgeArticleLink slug={article.slug} className="hover:text-seo-bright">{article.title}</KnowledgeArticleLink></h3>
        <KnowledgeArticleLink slug={article.slug} className="knowledge-text-link text-sm">Leer <ArrowRight size={14} aria-hidden="true" /></KnowledgeArticleLink>
      </div>)}</div>
    </section>
    <div className="mt-10"><DiagnosisCTA context={current?.area === 'marketing' ? '¿Dónde puede aportar valor la IA a tu captación?' : '¿Tu visibilidad está generando oportunidades reales?'} /></div>
  </div>;
}
